import React, { useState, useEffect } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";
import { Modal, Box, List, ListItem, ListItemText, Typography, Button } from "@mui/material";

export const getAvailableCameras = async () => {
  try {
    const devices = await AgoraRTC.getCameras();
    return devices;
  } catch (error) {
    console.error("Error fetching cameras:", error);
    return [];
  }
};

// Update the switchCamera function to handle switching the local streaming camera
export const switchCamera = async (localTrack, deviceId) => {
  if (!localTrack || typeof localTrack.setDevice !== "function") {
    console.error("Invalid localTrack: Make sure it's a valid video track.");
    alert("Error: Invalid video track.");
    return;
  }

  try {
    await localTrack.setDevice(deviceId);
    // console.log("Switched to camera:", deviceId);
  } catch (error) {
    // console.error("Error switching camera:", error);
  }
};

export const CameraSwitchModal = ({ open, onClose, onSwitchCamera, localTrack }) => {
  const [availableCameras, setAvailableCameras] = useState([]);

  useEffect(() => {
    const fetchCameras = async () => {
      const cameras = await getAvailableCameras();
      setAvailableCameras(cameras);
    };

    if (open) {
      fetchCameras();
    }
  }, [open]);

  const handleSwitchCamera = async (deviceId) => {
    if (!localTrack || typeof localTrack.setDevice !== "function") {
      console.error("Invalid localTrack: Make sure it's a valid video track.");
      alert("Error: Invalid video track.");
      return;
    }

    await switchCamera(localTrack, deviceId); // Switch the camera
    onSwitchCamera(); // Notify the parent component
    onClose(); // Close the modal
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="camera-modal-title"
      aria-describedby="camera-modal-description"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box className="camera-modal" sx={{ p: 4, backgroundColor: 'white', borderRadius: 2 }}>
        <Typography id="camera-modal-title" variant="h6" component="h2">
          Select a Camera
        </Typography>
        <List>
          {availableCameras.map((camera) => (
            <ListItem button key={camera.deviceId} onClick={() => handleSwitchCamera(camera.deviceId)}>
              <ListItemText primary={camera.label} />
            </ListItem>
          ))}
        </List>
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
};
